// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function Svg$Circle(props) {
  return JsxRuntime.jsx("circle", {
    cx: props.cx,
    cy: props.cy,
    fill: props.fill,
    r: props.r
  });
}

let Circle = {
  make: Svg$Circle
};

function Svg$Path(props) {
  return JsxRuntime.jsx("path", {
    d: props.d,
    fill: props.fill,
    fillRule: props.fillRule,
    filter: props.filter,
    stroke: props.stroke,
    strokeDasharray: props.strokeDasharray,
    strokeWidth: props.strokeWidth,
    transform: props.transform
  });
}

let Path = {
  make: Svg$Path
};

function Svg(props) {
  return JsxRuntime.jsx("svg", {
    children: props.children,
    className: props.className,
    role: props.role,
    style: props.style,
    height: props.height,
    width: props.width,
    fill: props.fill,
    stroke: props.stroke,
    viewBox: props.viewBox
  });
}

let make = Svg;

export {
  Circle,
  Path,
  make,
}
/* react/jsx-runtime Not a pure module */
